<template>
  <b-card>
    <b-card-header class="pb-10">
      <b-card-title>Age Group</b-card-title>
      <b-form-checkbox
        checked="false"
        class="custom-control-primary"
        name="check-button"
        switch
        inline
        @change="toggleCitizenShip"
      >
        <p v-if="citizenShip === 'i'">
          All </p>
        <p v-else-if="citizenShip === 'oci'">
          OCI
        </p>
      </b-form-checkbox>
    </b-card-header>

    <VueApexCharts
      height="400"
      type="bar"
      :options="options"
      :series="series[citizenShip]"
    />
  </b-card>
</template>

<script>
import {
  BCardHeader, BCardTitle, BCard, BFormCheckbox,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'

// colors
const chartColors = {
  column: {
    series1: '#FF8F1C',
    series2: '#FFAC58',
    series3: '#FFD8B0',
    bg: '#EEEEEE',
  },
}

export default {
  components: {
    BFormCheckbox,
    BCard,
    BCardTitle,
    BCardHeader,
    VueApexCharts,
  },
  props: {
    series: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      citizenShip: null,
      options: {
        chart: {
          id: 'Age Group Bar Chart',
          stacked: true,
          toolbar: {
            show: true,
          },
        },
        colors: [chartColors.column.series1, chartColors.column.series2, chartColors.column.series3],
        plotOptions: {
          bar: {
            columnWidth: '50%',
            backgroundBarRadius: 30,
            borderRadius: 30,
          },
        },
        legend: {
          show: true,
          position: 'top',
          fontSize: '14px',
          horizontalAlign: 'left',
        },
        stroke: {
          show: false,
          colors: ['transparent'],
        },
        grid: {
          xaxis: {
            lines: {
              show: false,
            },
          },
        },
        fill: {
          opacity: 1,
        },
        xaxis: {
          categories: ['03/03 to 09/03', '10/03 to 16/03', '17/03 to 23/03', '24/03 to 30/03', '31/03 to 06/04', '07/04 to 13/04', '14/04 to 20/04', '21/04 to 27/04', '28/04 to 03/05'],
        },
      },
    }
  },
  mounted() {
    this.citizenShip = 'i'
  },

  methods: {
    toggleCitizenShip() {
      this.citizenShip = (this.citizenShip === 'oci') ? 'i' : 'oci'
    },
  },
}
</script>
